module.exports = __webpack_public_path__ + "media/images/icon_new_member_register_sp-f26784e2ee08483edd1ed5ae9997dae1.png";